export default "__VITE_PUBLIC_ASSET__35df72de__"